<div class="modal-header" ngxModalDraggable>
    <h2 class="modal-title">{{ title }}</h2>
</div>
<div class="modal-body">
    <div>
        <dx-data-grid #auditLogsMasterGrid [dataSource]="auditLogs" [showBorders]="true" height="500" (onSelectionChanged)="selectionChange($event)">
            <dxi-column dataField="when" caption="Date" [dataType]="'datetime'" width="150" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
            <dxi-column dataField="entityTypeName" caption="Table" width="150"></dxi-column>
            <dxi-column dataField="action" width="150"></dxi-column>
            <dxi-column dataField="userName" caption="User" width="150"></dxi-column>
            <dxi-column dataField="changesHTML" caption="Changes" [encodeHtml]="false"></dxi-column>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
        </dx-data-grid>
    </div>
    <div class="mt-3">
        <dx-data-grid #auditLogChildGrid [dataSource]="auditLog" [showBorders]="true" height="300">
            <dxi-column dataField="columnName" dataType="string" caption="Field" width="150"></dxi-column>
            <dxi-column dataField="originalValue" dataType="string" caption="Old Value"></dxi-column>
            <dxi-column dataField="newValue" dataType="string" caption="New Value"></dxi-column>

            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
        </dx-data-grid>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary me-auto" (click)="export()">Export</button>
    <button class="btn btn-secondary" (click)="close()">Close</button>
</div>
